(() => {
  const SEL = {
    modal: '[data-store-locator-modal]', panel: '[data-store-locator-panel]', open: '[data-store-locator-open]',
    close: '[data-store-locator-close]', initial: '[data-store-view="initial"]', blocked: '[data-store-view="blocked"]',
    results: '[data-store-view="results"]', favorite: '[data-store-view="favorite"]', useLocation: '[data-use-location]',
    postalForm: '[data-postal-form]', postal: '[data-postal-input]', stateList: '[data-state-list]', resultsList: '[data-store-results]',
    resultsTitle: '[data-results-title]', select: '[data-select-store]', mapAll: '[data-map-all]', change: '[data-change-store]',
    mapStore: '[data-map-store]', favoriteContent: '[data-favorite-content]', loginLink: '[data-login-link]', error: '[data-store-error]', headerLabel: '[data-store-header-label]'
  };
  const MAX_DISTANCE_KM = 15;

  class StoreLocatorModal {
    constructor(root) {
      this.root = root;
      this.modal = root.querySelector(SEL.modal);
      this.selectedStore = null;
      this.results = [];
      this.searchContext = null;
      this.bind();
      // Búsqueda por estado desactivada: solo ubicación actual o código postal.
      // this.renderStates();
      this.loadFavorite();
    }

    bind() {
      document.querySelectorAll(SEL.open).forEach((button) => button.addEventListener('click', () => this.open()));
      this.root.querySelectorAll(SEL.close).forEach((button) => button.addEventListener('click', () => this.close()));
      this.modal?.addEventListener('click', (event) => { if (event.target === this.modal) this.close(); });
      this.root.querySelector(SEL.useLocation)?.addEventListener('click', () => this.useLocation());
      this.root.querySelectorAll(SEL.postalForm).forEach((form) => {
        form.addEventListener('submit', (event) => {
          event.preventDefault();
          this.searchPostal(form);
        });
        // Busca en automático al completar los 5 dígitos, sin esperar Enter.
        form.querySelector(SEL.postal)?.addEventListener('input', (event) => {
          if (/^\d{5}$/.test(event.target.value.trim())) this.searchPostal(form);
        });
      });
      this.root.querySelector(SEL.resultsList)?.addEventListener('click', (event) => this.onResultsClick(event));
      this.root.querySelector(SEL.select)?.addEventListener('click', () => this.confirmSelected());
      this.root.querySelector(SEL.mapAll)?.addEventListener('click', () => this.openMapForContext());
      this.root.querySelector(SEL.change)?.addEventListener('click', () => this.changeStore());
      this.root.querySelector(SEL.mapStore)?.addEventListener('click', () => this.openSelectedStoreMap());
      document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && this.modal?.dataset.open === 'true') this.close(); });
    }

    open() {
      if (!this.modal) return;
      this.modal.dataset.open = 'true';
      this.modal.removeAttribute('hidden');
      document.documentElement.classList.add('store-locator-lock');
      this.watchViewport(true);
      if (!(window.ShasaStoreLocatorConfig || {}).customerId) this.showLogin();
      else if (this.favoriteResponse) this.showFavorite(this.favoriteResponse);
      else this.show('initial');
    }

    // Invitados: pedimos iniciar sesión y regresamos a la página actual al terminar.
    showLogin() {
      const link = this.root.querySelector(SEL.loginLink);
      if (link) {
        const returnTo = window.location.pathname + window.location.search;
        link.href = `/customer_authentication/login?return_to=${encodeURIComponent(returnTo)}`;
      }
      this.show('login');
    }

    close() {
      if (!this.modal) return;
      this.modal.dataset.open = 'false';
      this.modal.setAttribute('hidden', '');
      document.documentElement.classList.remove('store-locator-lock');
      this.watchViewport(false);
    }

    /*
     * iOS Safari no encoge la pantalla al abrir el teclado: solo se reduce el "visual viewport"
     * y la página se desplaza para mostrar el input. Ajustamos el modal al área visible real.
     *
     * iOS 26: el área visible termina arriba de la barra flotante de Safari ("shasa.com" + AutoFill),
     * que es translúcida y deja ver la página. Los elementos fixed no se pintan fuera del área visible,
     * así que tapamos esa franja con un bloque blanco position:absolute en coordenadas del documento
     * (visualViewport.pageTop), que sí se pinta ahí.
     */
    watchViewport(active) {
      const viewport = window.visualViewport;
      if (!viewport || !this.modal) return;
      if (!this.syncViewport) {
        this.syncViewport = () => {
          if (!window.matchMedia('(max-width: 749px)').matches) return;
          this.modal.style.top = `${viewport.offsetTop}px`;
          this.modal.style.height = `${viewport.height}px`;
          this.modal.style.bottom = 'auto';
          const keyboardOpen = window.innerHeight - viewport.height > 120;
          this.modal.classList.toggle('is-keyboard-open', keyboardOpen);
          const filler = this.keyboardFiller();
          filler.hidden = !keyboardOpen;
          if (keyboardOpen) filler.style.top = `${viewport.pageTop + viewport.height - 1}px`;
        };
      }
      const method = active ? 'addEventListener' : 'removeEventListener';
      viewport[method]('resize', this.syncViewport);
      viewport[method]('scroll', this.syncViewport);
      if (active) {
        this.syncViewport();
      } else {
        this.modal.style.top = this.modal.style.height = this.modal.style.bottom = '';
        this.modal.classList.remove('is-keyboard-open');
        if (this.filler) this.filler.hidden = true;
      }
    }

    keyboardFiller() {
      if (!this.filler) {
        this.filler = document.createElement('div');
        this.filler.className = 'store-locator-keyboard-filler';
        this.filler.setAttribute('aria-hidden', 'true');
        this.filler.hidden = true;
        // Hijo directo de <html> para que "top" sea relativo al documento y no al <body>.
        document.documentElement.appendChild(this.filler);
      }
      return this.filler;
    }

    show(name) {
      this.root.querySelectorAll('[data-store-view]').forEach((view) => {
        view.hidden = view.dataset.storeView !== name;
      });
      this.clearError();
    }

    clearError() {
      const error = this.root.querySelector(SEL.error);
      if (error) { error.textContent = ''; error.hidden = true; }
    }

    setError(message) {
      const error = this.root.querySelector(SEL.error);
      if (error) { error.textContent = message; error.hidden = false; }
    }

    /* Búsqueda por estado desactivada: solo ubicación actual o código postal.
    renderStates() {
      const container = this.root.querySelector(SEL.stateList);
      if (!container) return;
      container.innerHTML = window.ShasaStoreLocator.uniqueStates()
        .map(({ code, label }) => `<button type="button" class="store-locator__state" data-state-code="${code}">${label}</button>`)
        .join('');
      container.addEventListener('click', (event) => {
        const button = event.target.closest('[data-state-code]');
        if (!button) return;
        this.searchState(button.dataset.stateCode);
      });
    }
    */

    async loadFavorite() {
      const config = window.ShasaStoreLocatorConfig || {};
      if (!config.customerId) return;
      // getFavoriteStore() devuelve el objeto normalizado ({ storeCode, store, ... }),
      // no la respuesta cruda de la API ({ data: { store, store_code } }) que espera showFavorite().
      const favorite = await window.ShasaStoreLocator.getFavoriteStore();
      if (!favorite?.storeCode) return;
      this.favoriteResponse = { data: { store_code: favorite.storeCode, store: favorite.store || this.localStoreData(favorite.storeCode) } };
      this.updateHeader(this.favoriteResponse.data.store);
    }

    // Respaldo si el backend no devuelve el detalle de la tienda: usamos shasa-stores.js.
    localStoreData(storeCode) {
      const store = window.ShasaStoreLocator.getStores().find((item) => item.storeCode === storeCode);
      if (!store) return { name: '' };
      return { name: store.displayName, address: { address1: store.address1, municipality: store.municipality, city: store.city } };
    }

    updateHeader(store) {
      const label = document.querySelector(SEL.headerLabel);
      if (!label || !store) return;
      const name = String(store.name || '').replace(/^Shasa\s+/i, '').replace(/^.*?,\s*/, '');
      label.textContent = name || 'Tu tienda';
      label.closest('[data-store-locator-open]')?.classList.add('has-store');
    }

    async useLocation() {
      const button = this.root.querySelector(SEL.useLocation);
      if (button?.classList.contains('is-loading')) return;
      this.setLoading(button, true);
      try {
        const coords = await window.ShasaStoreLocator.requestUserLocation();
        this.searchContext = { mode: 'location', lat: coords.lat, lng: coords.lng };
        const stores = window.ShasaStoreLocator.storesNear(coords, MAX_DISTANCE_KM).slice(0, 3);
        this.renderResults(stores, `${stores.length} tienda${stores.length === 1 ? '' : 's'} cerca de ti`);
      } catch (error) {
        if (error?.code === 1) this.show('blocked');
        else this.setError('No pudimos obtener tu ubicación. Busca por código postal.');
      } finally {
        this.setLoading(button, false);
      }
    }

    // Spinner sobre el botón mientras se espera la respuesta; el texto se oculta con CSS.
    setLoading(button, isLoading) {
      if (!button) return;
      button.classList.toggle('is-loading', isLoading);
      button.disabled = isLoading;
      button.setAttribute('aria-busy', String(isLoading));
    }

    async searchPostal(form) {
      const input = form?.querySelector(SEL.postal);
      const postalCode = input?.value?.trim();

      if (!postalCode) return;

      try {
        const coords = await window.ShasaStoreLocator.geocodePostalCode(postalCode);

        this.searchContext = {
          mode: 'postal',
          postal_code: coords.postalCode,
          lat: coords.lat,
          lng: coords.lng
        };

        const stores = window.ShasaStoreLocator
          .storesNear(coords, MAX_DISTANCE_KM)
          .slice(0, 3);

        this.renderResults(
          stores,
          `${stores.length} tienda${stores.length === 1 ? '' : 's'} cerca de ${coords.postalCode}`
        );
      } catch (error) {
        console.error('[StoreLocator] Postal search failed:', error);

        this.setError(
          'No encontramos ese código postal. Verifica los 5 dígitos e inténtalo de nuevo.'
        );
      }
    }

    /* Búsqueda por estado desactivada: solo ubicación actual o código postal.
    searchState(stateCode) {
      const stores = window.ShasaStoreLocator.storesByState(stateCode);
      this.searchContext = { mode: 'state', state: stateCode };
      const label = window.ShasaStoreLocator.STATE_LABELS[stateCode] || stateCode;
      this.renderResults(stores, `${stores.length} tienda${stores.length === 1 ? '' : 's'} en ${label}`);
    }
    */

    renderResults(stores, title) {
      this.results = stores;
      this.selectedStore = null;
      this.show('results');
      //const titleEl = this.root.querySelector(SEL.resultsTitle);
      //if (titleEl) titleEl.textContent = title;
      const list = this.root.querySelector(SEL.resultsList);
      if (list) {
        list.innerHTML = stores.length ? stores.map((store) => this.storeCard(store)).join('') : '<p class="store-locator__empty">No encontramos tiendas para esta búsqueda.</p>';
      }
      this.updateSelectButton();
    }

    storeCard(store) {
      const distance = Number.isFinite(store.distanceKm) ? `<span class="store-locator__result-distance">A ${store.distanceKm.toFixed(1)} km</span>` : '';
      const address = [store.address1, store.municipality, store.state].filter(Boolean).join(', ');
      return `<button type="button" class="store-locator__result" data-store-code="${store.storeCode}">
        <span class="store-locator__result-title"><strong>${store.displayName}</strong></span>
        <span class="store-locator__result-address">${address}</span>
        ${distance}
        <span class="store-locator__result-status">Horario disponible al seleccionar la tienda</span>
      </button>`;
    }

    onResultsClick(event) {
      const card = event.target.closest('[data-store-code]');
      if (!card) return;
      this.root.querySelectorAll('[data-store-code]').forEach((node) => node.classList.remove('is-selected'));
      card.classList.add('is-selected');
      this.selectedStore = this.results.find((store) => store.storeCode === card.dataset.storeCode) || null;
      this.updateSelectButton();
    }

    updateSelectButton() {
      const selectButton = this.root.querySelector(SEL.select);
      if (!selectButton) return;
      selectButton.disabled = !this.selectedStore;
      selectButton.textContent = this.selectedStore ? 'Seleccionar tienda' : 'Selecciona tu tienda';
    }

    async confirmSelected() {
      if (!this.selectedStore) return;
      const button = this.root.querySelector(SEL.select);
      if (button) button.disabled = true;
      try {
        const response = await window.ShasaStoreLocator.saveFavoriteStore(this.selectedStore.storeCode);
        this.favoriteResponse = response;
        this.updateHeader(response.data?.store || { name: this.selectedStore.displayName });
        // Cerramos en lugar de mostrar la vista de tienda seleccionada; open() la muestra al reabrir.
        this.close();
      } catch (error) {
        console.error('[StoreLocator] Save favorite store failed:', error);
        this.setError('No pudimos guardar tu tienda. Inténtalo nuevamente.');
        if (button) button.disabled = false;
      }
    }

    showFavorite(response) {
      const data = response?.data || {};
      const storeCode = data.store_code || this.selectedStore?.storeCode;
      this.show('favorite');
      this.favoriteStoreCode = storeCode;
      const content = this.root.querySelector(SEL.favoriteContent);
      if (!content) return;
      // Preferimos los datos de shasa-stores.js para que nombre y dirección coincidan con la lista de resultados.
      const local = window.ShasaStoreLocator.getStores().find((store) => store.storeCode === storeCode);
      const apiStore = data.store || {};
      const apiAddress = apiStore.address || {};
      const name = local?.displayName || apiStore.name || 'Tu tienda Shasa';
      const address = (local
        ? [local.address1, local.municipality, local.state]
        : [apiAddress.address1, apiAddress.municipality, apiAddress.city]
      ).filter(Boolean).join(', ');
      // La distancia solo se conoce si la tienda se acaba de elegir desde una búsqueda.
      const distanceKm = this.selectedStore?.storeCode === storeCode ? this.selectedStore.distanceKm : null;
      const distance = Number.isFinite(distanceKm) ? `<span class="store-locator__result-distance">A ${distanceKm.toFixed(1)} km</span>` : '';
      content.innerHTML = `<p class="store-locator__favorite-eyebrow">TIENDA SELECCIONADA</p>
        <strong class="store-locator__favorite-name">${name}</strong>
        <span class="store-locator__result-address">${address}</span>
        ${distance}`;
    }

    changeStore() {
      this.show('initial');
    }

    openMapForContext() {
      location.href = window.ShasaStoreLocator.mapUrl(this.searchContext || {});
    }

    openSelectedStoreMap() {
      const storeCode = this.favoriteStoreCode || this.selectedStore?.storeCode;
      if (storeCode) location.href = window.ShasaStoreLocator.mapUrl({ store: storeCode });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const root = document.querySelector('[data-store-locator-root]');
    if (root && window.ShasaStoreLocator) window.shasaStoreLocatorModal = new StoreLocatorModal(root);
  });
})();
